import * as React from 'react';

import { IPage, IPlaceHolder, IDocument, IDragInfo } from '../../../../../../../infrastructure/interfaces';
import PageEditor from '../../../common/PageEditor';

export interface IPageLayoutProps {
  page: IPage;
  second: boolean;
  handleDrop(index: number, data: IPlaceHolder, dragInfo: IDragInfo): void;
  removeProduct(data: any, index: number): void;
  document: IDocument | null;
}

export interface IPageLayoutState { }

export default class PageLayout extends React.Component<IPageLayoutProps, IPageLayoutState> {
  constructor(props: IPageLayoutProps) {
    super(props);
  }

  render() {
    return (this.props.page.placeholders.map((p, i) => {
      const index = this.props.second ? 4 + i : i;
      return (
        <PageEditor
          accepts={p.accepts}
          lastDroppedItem={p}
          onDrop={(data: any, type: any) => this.props.handleDrop(index, data, type)}
          removeProduct={this.props.removeProduct}
          index={index}
          key={i}
          page={this.props.page}
          document={this.props.document}
          layout="Brochure"
        />);
    }));
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Brochure/Components/PageLayout/PageLayout.tsx